import { Button, Grid, Typography } from '@material-ui/core';
import { CenteredGrid } from '@up2rent/ui';
import React from 'react';
import { useIntl } from 'react-intl';

const LazyError: React.FC = () => {
  const { formatMessage } = useIntl();
  return (
    <CenteredGrid>
      <Grid>
        <Typography variant="h5">{formatMessage({ id: 'lazyError' })}</Typography>
        <Typography variant="h6">{formatMessage({ id: 'lazyError2' })}</Typography>
        <Button onClick={() => location.reload()}>{formatMessage({ id: 'refresh' })}</Button>
      </Grid>
    </CenteredGrid>
  );
};
export default LazyError;
